var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("a", { attrs: { id: "page-top" } }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isBuy,
            expression: "!isBuy",
          },
        ],
        attrs: { id: "kolorowe-karty-page" },
      },
      [
        _c(
          "div",
          { staticClass: "jumbo" },
          [
            _vm._t("head", function () {
              return [_vm._m(0)]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c("kolorowe-karty-kalkulator", {
          attrs: { karty: _vm.karty, v: _vm.$v, zamow: _vm.zamow },
          on: { calculated: _vm.calculated },
          model: {
            value: _vm.kalkulator,
            callback: function ($$v) {
              _vm.kalkulator = $$v
            },
            expression: "kalkulator",
          },
        }),
        _vm._v(" "),
        _c(
          "section",
          { attrs: { id: "tresc" } },
          [
            _vm._t("tresc", function () {
              return [
                _c("h2", { staticClass: "text-center" }, [
                  _vm._v("Dlaczego Kolorowe Karty Intercity to dobry wybór?"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center d-none" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { href: "#" },
                          on: { click: _vm.kalkulatorS },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("ic_kk_zamow")))]
                      ),
                    ]),
                  ]),
                ]),
              ]
            }),
          ],
          2
        ),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.isSent && _vm.isBuy
      ? _c(
          "div",
          { staticClass: "ic-forms", attrs: { id: "kolorowe-karty" } },
          [
            _c(
              "FormWrapper",
              { attrs: { validator: _vm.$v.form } },
              [
                _c("div", [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6 offset-md-1 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "karta", class: _vm.form.card.waznosc },
                        [
                          _c("div", { staticClass: "head" }, [
                            _c("p", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("ic_kk_karta_intercity"))
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.waznosc))]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.typ))]),
                              _c("br"),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("ic_kk_klasa")) +
                                    " " +
                                    _vm._s(_vm.form.card.klasa)
                                ),
                              ]),
                              _vm._v(" - "),
                              _c("span", [_vm._v(_vm._s(_vm.discount))]),
                              _vm._v(" "),
                              _c("br"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "waznosc" }, [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.form.card.date_from) +
                                "\n                "
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-4 offset-md-1 col-12",
                        attrs: { id: "karta" },
                      },
                      [
                        _c("h1", [_vm._v(_vm._s(_vm.$t("ic_kk_twoja_karta")))]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("ic_kk_zloz_zamowienie"))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "cena" }, [
                          _vm._v(
                            _vm._s(_vm._f("formatNumber")(_vm.cena)) +
                              " zł / " +
                              _vm._s(_vm.cena_okres)
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "IcFormRowWrapper",
                          {
                            attrs: {
                              id: "cardType",
                              name: "cardType",
                              aria: _vm.$t("ic_kk_pole_wymagane"),
                              labelWidth: 0,
                              controlWidth: 12,
                            },
                          },
                          [
                            [
                              _c(
                                "fieldset",
                                [
                                  _c("legend", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("ic_kk_rodzaj_zamawiajacego")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("IcRadioGroup", {
                                    attrs: {
                                      id: "cardType",
                                      options: _vm.cardTypeOptions,
                                      outerClass: "radio-border",
                                    },
                                    model: {
                                      value: _vm.form.cardType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "cardType", $$v)
                                      },
                                      expression: "form.cardType",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel" }, [
                  _c("div", { staticClass: "panel-header" }, [
                    _vm.form.cardType == "F"
                      ? _c("h2", [_vm._v(_vm._s(_vm.$t("ic_kk_dane_firmy")))])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.cardType == "P"
                      ? _c("h2", [_vm._v(_vm._s(_vm.$t("ic_kk_twoje_dane")))])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.form.cardType == "F"
                    ? _c(
                        "div",
                        { staticClass: "row", attrs: { id: "company" } },
                        [
                          _c(
                            "div",
                            { staticClass: "col-md-8 col-12" },
                            [
                              _c("IcFormRowWrapper", {
                                attrs: {
                                  rowElement: "IcFormRow",
                                  id: "company_company",
                                  name: "company.company",
                                  aria: _vm.$t("ic_kk_pole_wymagane"),
                                  label: _vm.$t("ic_kk_nazwa_firmy"),
                                  labelWidth: 4,
                                  controlWidth: 8,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ validator }) {
                                        return [
                                          _c("IcInput", {
                                            attrs: {
                                              id: "company_company",
                                              placeholder: _vm.$t(
                                                "ic_kk_nazwa_firmy_ph"
                                              ),
                                            },
                                            model: {
                                              value: _vm.form.company.company,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form.company,
                                                  "company",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.company.company",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4076064679
                                ),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-4 col-12" },
                            [
                              _c("IcFormRowWrapper", {
                                attrs: {
                                  rowElement: "IcFormRow",
                                  id: "vatid",
                                  name: "company.vatid",
                                  aria: _vm.$t("ic_kk_pole_wymagane"),
                                  label: _vm.$t("ic_kk_nip"),
                                  labelWidth: 4,
                                  controlWidth: 8,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ validator }) {
                                        return [
                                          _c("IcInput", {
                                            attrs: {
                                              id: "vatid",
                                              placeholder:
                                                _vm.$t("ic_kk_nip_ph"),
                                            },
                                            model: {
                                              value: _vm.form.company.vatid,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form.company,
                                                  "vatid",
                                                  $$v
                                                )
                                              },
                                              expression: "form.company.vatid",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3910055837
                                ),
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4 col-6" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "contact_name",
                            name: "person.name",
                            aria: _vm.$t("ic_kk_pole_wymagane"),
                            label: _vm.$t("ic_kk_imie_nazwisko"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ validator }) {
                                  return [
                                    _c("IcInput", {
                                      attrs: {
                                        id: "contact_name",
                                        placeholder: _vm.$t(
                                          "ic_kk_kontakt_imie_nazwisko_ph"
                                        ),
                                      },
                                      model: {
                                        value: _vm.form.person.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form.person, "name", $$v)
                                        },
                                        expression: "form.person.name",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            982974259
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4 col-6" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "email",
                            name: "person.email",
                            aria: _vm.$t("ic_kk_pole_wymagane"),
                            label: _vm.$t("ic_kk_email"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ validator }) {
                                  return [
                                    _c("IcInput", {
                                      attrs: {
                                        id: "email",
                                        placeholder: _vm.$t("ic_kk_email_ph"),
                                      },
                                      model: {
                                        value: _vm.form.person.email,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.person,
                                            "email",
                                            $$v
                                          )
                                        },
                                        expression: "form.person.email",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1368640948
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4 col-12" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "phone",
                            name: "person.phone",
                            aria: _vm.$t("ic_kk_pole_wymagane"),
                            label: _vm.$t("ic_kk_telefon"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ validator }) {
                                  return [
                                    _c("IcInput", {
                                      attrs: {
                                        id: "phone",
                                        placeholder: _vm.$t("ic_kk_telefon_ph"),
                                      },
                                      model: {
                                        value: _vm.form.person.phone,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.person,
                                            "phone",
                                            $$v
                                          )
                                        },
                                        expression: "form.person.phone",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1760238279
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-8 col-12" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "street",
                            name: "address.street",
                            aria: _vm.$t("ic_kk_pole_wymagane"),
                            label: _vm.$t("ic_kk_ulica"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ validator }) {
                                  return [
                                    _c("IcInput", {
                                      attrs: {
                                        id: "street",
                                        placeholder: _vm.$t("ic_kk_ulica_ph"),
                                      },
                                      model: {
                                        value: _vm.form.address.street,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "street",
                                            $$v
                                          )
                                        },
                                        expression: "form.address.street",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3646614089
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-2 col-6" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "streetNo",
                            name: "address.streetNo",
                            aria: _vm.$t("ic_kk_pole_wymagane"),
                            label: _vm.$t("ic_kk_ulica_nr_domu"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ validator }) {
                                  return [
                                    _c("IcInput", {
                                      attrs: {
                                        id: "streetNo",
                                        placeholder: _vm.$t(
                                          "ic_kk_ulica_nr_domu_ph"
                                        ),
                                      },
                                      model: {
                                        value: _vm.form.address.streetNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "streetNo",
                                            $$v
                                          )
                                        },
                                        expression: "form.address.streetNo",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1403124742
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-2 col-6" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "apartment",
                            name: "address.apartment",
                            label: _vm.$t("ic_kk_ulica_nr_lokalu"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ validator }) {
                                  return [
                                    _c("IcInput", {
                                      attrs: {
                                        id: "apartment",
                                        placeholder: _vm.$t(
                                          "ic_kk_ulica_nr_lokalu_ph"
                                        ),
                                      },
                                      model: {
                                        value: _vm.form.address.apartment,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "apartment",
                                            $$v
                                          )
                                        },
                                        expression: "form.address.apartment",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            72669893
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-8 col-6" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "city",
                            name: "address.city",
                            aria: _vm.$t("ic_kk_pole_wymagane"),
                            label: _vm.$t("ic_kk_miejscowosc"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ validator }) {
                                  return [
                                    _c("IcInput", {
                                      attrs: {
                                        id: "city",
                                        placeholder: _vm.$t(
                                          "ic_kk_miejscowosc_ph"
                                        ),
                                      },
                                      model: {
                                        value: _vm.form.address.city,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "city",
                                            $$v
                                          )
                                        },
                                        expression: "form.address.city",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1968572519
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4 col-6" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "zip",
                            name: "address.zip",
                            aria: _vm.$t("ic_kk_pole_wymagane"),
                            label: _vm.$t("ic_kk_kod_pocztowy"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ validator }) {
                                  return [
                                    _c("IcInput", {
                                      attrs: {
                                        id: "zip",
                                        placeholder: _vm.$t(
                                          "ic_kk_kod_pocztowy_ph"
                                        ),
                                      },
                                      model: {
                                        value: _vm.form.address.zip,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form.address, "zip", $$v)
                                        },
                                        expression: "form.address.zip",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3361768983
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-3 col-12" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "discount",
                            name: "card.discount",
                            aria: _vm.$t("ic_kk_pole_wymagane"),
                            label: _vm.$t("ic_kk_taryfa"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ validator }) {
                                  return [
                                    _c("IcSelect", {
                                      attrs: {
                                        id: "discount",
                                        values: _vm.discountOptions,
                                      },
                                      model: {
                                        value: _vm.form.card.discount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.card,
                                            "discount",
                                            $$v
                                          )
                                        },
                                        expression: "form.card.discount",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2538279437
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.card.type == "imienna"
                      ? _c(
                          "div",
                          { staticClass: "col-md-3 col-6" },
                          [
                            _c("IcFormRowWrapper", {
                              attrs: {
                                rowElement: "IcFormRow",
                                id: "owner",
                                name: "card.owner",
                                aria: _vm.$t("ic_kk_pole_wymagane"),
                                label: _vm.$t("ic_kk_kontakt_imie_nazwisko"),
                                labelWidth: 4,
                                controlWidth: 8,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ validator }) {
                                      return [
                                        _c("IcInput", {
                                          attrs: {
                                            id: "owner",
                                            placeholder: _vm.$t(
                                              "ic_kk_kontakt_imie_nazwisko_ph"
                                            ),
                                          },
                                          model: {
                                            value: _vm.form.card.owner,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.card,
                                                "owner",
                                                $$v
                                              )
                                            },
                                            expression: "form.card.owner",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1895710637
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-3 col-12" },
                      [
                        _c("IcFormRowWrapper", {
                          attrs: {
                            rowElement: "IcFormRow",
                            id: "date_from",
                            name: "card.date_from",
                            aria: _vm.$t("aria_required_date"),
                            label: _vm.$t("ic_kk_data_rozpoczecia_karty"),
                            labelWidth: 4,
                            controlWidth: 8,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ validator }) {
                                  return [
                                    _c("ic-date-picker", {
                                      attrs: {
                                        id: "date_from",
                                        title: "Wybierz datę",
                                        aria: "Strzałka w górę dół, następny poprzedni dzień.",
                                        minDate: _vm.minDate,
                                        endDate: _vm.endDate,
                                      },
                                      model: {
                                        value: _vm.form.card.date_from,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.card,
                                            "date_from",
                                            $$v
                                          )
                                        },
                                        expression: "form.card.date_from",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3441089463
                          ),
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "IcCheckbox",
                          {
                            attrs: { val: 1, id: "post_address" },
                            model: {
                              value: _vm.form.post_address,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "post_address", $$v)
                              },
                              expression: "form.post_address",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("ic_kk_adres_do_korespondencji"))
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.form.post_address
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-8" },
                          [
                            _c("IcFormRowWrapper", {
                              attrs: {
                                rowElement: "IcFormRow",
                                id: "street",
                                name: "address.street",
                                aria: _vm.$t("ic_kk_pole_wymagane"),
                                label: _vm.$t("ic_kk_ulica"),
                                labelWidth: 4,
                                controlWidth: 8,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ validator }) {
                                      return [
                                        _c("IcInput", {
                                          attrs: {
                                            id: "street",
                                            placeholder:
                                              _vm.$t("ic_kk_ulica_ph"),
                                          },
                                          model: {
                                            value: _vm.form.post_street,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "post_street",
                                                $$v
                                              )
                                            },
                                            expression: "form.post_street",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3118762966
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-2" },
                          [
                            _c("IcFormRowWrapper", {
                              attrs: {
                                rowElement: "IcFormRow",
                                id: "streetNo",
                                name: "address.streetNo",
                                aria: _vm.$t("ic_kk_pole_wymagane"),
                                label: _vm.$t("ic_kk_ulica_nr_domu"),
                                labelWidth: 4,
                                controlWidth: 8,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ validator }) {
                                      return [
                                        _c("IcInput", {
                                          attrs: {
                                            id: "streetNo",
                                            placeholder: _vm.$t(
                                              "ic_kk_ulica_nr_domu_ph"
                                            ),
                                          },
                                          model: {
                                            value: _vm.form.post_street_no,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "post_street_no",
                                                $$v
                                              )
                                            },
                                            expression: "form.post_street_no",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1537536742
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-2" },
                          [
                            _c("IcFormRowWrapper", {
                              attrs: {
                                rowElement: "IcFormRow",
                                id: "apartment",
                                name: "address.apartment",
                                label: _vm.$t("ic_kk_ulica_nr_lokalu"),
                                labelWidth: 4,
                                controlWidth: 8,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ validator }) {
                                      return [
                                        _c("IcInput", {
                                          attrs: {
                                            id: "apartment",
                                            placeholder: _vm.$t(
                                              "ic_kk_ulica_nr_lokalu_ph"
                                            ),
                                          },
                                          model: {
                                            value:
                                              _vm.form.post_street_apartment,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "post_street_apartment",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.post_street_apartment",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3016543460
                              ),
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.post_address
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-8" },
                          [
                            _c("IcFormRowWrapper", {
                              attrs: {
                                rowElement: "IcFormRow",
                                id: "city",
                                name: "address.city",
                                aria: _vm.$t("ic_kk_pole_wymagane"),
                                label: _vm.$t("ic_kk_miejscowosc"),
                                labelWidth: 4,
                                controlWidth: 8,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ validator }) {
                                      return [
                                        _c("IcInput", {
                                          attrs: {
                                            id: "city",
                                            placeholder: _vm.$t(
                                              "ic_kk_miejscowosc_ph"
                                            ),
                                          },
                                          model: {
                                            value: _vm.form.post_city,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "post_city",
                                                $$v
                                              )
                                            },
                                            expression: "form.post_city",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2810782520
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-4" },
                          [
                            _c("IcFormRowWrapper", {
                              attrs: {
                                rowElement: "IcFormRow",
                                id: "zip",
                                name: "address.zip",
                                aria: _vm.$t("ic_kk_pole_wymagane"),
                                label: _vm.$t("ic_kk_kod_pocztowy"),
                                labelWidth: 4,
                                controlWidth: 8,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ validator }) {
                                      return [
                                        _c("IcInput", {
                                          attrs: {
                                            id: "zip",
                                            placeholder: _vm.$t(
                                              "ic_kk_kod_pocztowy_ph"
                                            ),
                                          },
                                          model: {
                                            value: _vm.form.post_zip,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "post_zip",
                                                $$v
                                              )
                                            },
                                            expression: "form.post_zip",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                495808872
                              ),
                            }),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel" }, [
                  _c("div", { staticClass: "panel-header" }, [
                    _c("h2", [_vm._v(" " + _vm._s(_vm.$t("ic_kk_platnosc")))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "panel-body" }, [
                    _c("p", [
                      _c("small", {
                        domProps: { innerHTML: _vm._s(_vm.$t("ic_kk_uwaga")) },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "boxes panel-body" },
                    [
                      _c(
                        "IcFormRowWrapper",
                        {
                          attrs: {
                            id: "paymentType",
                            name: "paymentType",
                            aria: _vm.$t("ic_kk_pole_wymagane"),
                            labelWidth: 0,
                            controlWidth: 12,
                          },
                        },
                        [
                          [
                            _c(
                              "fieldset",
                              [
                                _c("legend", { staticClass: "sr-only" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("ic_kk_wybierz_rodzaj_platnosci")
                                      ) +
                                      " "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("IcRadioGroup", {
                                  attrs: {
                                    id: "paymentType",
                                    options: _vm.paymentTypeOptions,
                                    outerClass: "payment box",
                                  },
                                  model: {
                                    value: _vm.form.paymentType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "paymentType", $$v)
                                    },
                                    expression: "form.paymentType",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "panel" }, [
                  _c("div", { staticClass: "panel-header" }, [
                    _c("h2", {
                      domProps: { innerHTML: _vm._s(_vm.$t("ic_kk_dostawa")) },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "boxes panel-body" },
                    [
                      _c(
                        "IcFormRowWrapper",
                        {
                          attrs: {
                            id: "deliveryType",
                            name: "deliveryType",
                            aria: _vm.$t("ic_kk_pole_wymagane"),
                            labelWidth: 0,
                            controlWidth: 12,
                          },
                        },
                        [
                          [
                            _c(
                              "fieldset",
                              [
                                _c("legend", { staticClass: "sr-only" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("ic_kk_wybierz_metode_dostawy")
                                      ) +
                                      " "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("IcRadioGroup", {
                                  attrs: {
                                    id: "deliveryType",
                                    options: _vm.deliveryTypeOptions,
                                    outerClass: "delivery box",
                                  },
                                  model: {
                                    value: _vm.form.deliveryType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "deliveryType", $$v)
                                    },
                                    expression: "form.deliveryType",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cena" }, [
                  _c("span", [
                    _vm._v(" " + _vm._s(_vm.$t("ic_kk_do_zaplaty")) + ":"),
                  ]),
                  _vm._v(" "),
                  _c("b", { staticClass: "mt-5 mb-5" }, [
                    _vm._v(_vm._s(_vm._f("formatNumber")(_vm.cena)) + " zł"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-5" }),
                _vm._v(" "),
                _c("IcFormAgreements", {
                  attrs: {
                    text: false,
                    header: false,
                    modal: true,
                    name: "akceptacja_dane",
                    label: _vm.$t("ic_kk_akceptacja_1"),
                    content: "ic_kk_agreements",
                  },
                  model: {
                    value: _vm.form.akceptacja_dane,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "akceptacja_dane", $$v)
                    },
                    expression: "form.akceptacja_dane",
                  },
                }),
                _vm._v(" "),
                _c("IcFormAgreements", {
                  attrs: {
                    header: false,
                    label: _vm.$t("ic_kk_regulamin"),
                    text: false,
                    name: "regulamin",
                  },
                  model: {
                    value: _vm.form.regulamin,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "regulamin", $$v)
                    },
                    expression: "form.regulamin",
                  },
                }),
                _vm._v(" "),
                _c("IcFormAgreements", {
                  attrs: {
                    header: false,
                    label: _vm.$t("ic_kk_akceptacja_2"),
                    text: false,
                  },
                  model: {
                    value: _vm.form.akceptacja_2,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "akceptacja_2", $$v)
                    },
                    expression: "form.akceptacja_2",
                  },
                }),
                _vm._v(" "),
                _c("IcFormAgreements", {
                  attrs: {
                    header: false,
                    label: _vm.$t("ic_kk_akceptacja_3"),
                    text: false,
                  },
                  model: {
                    value: _vm.form.akceptacja_1,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "akceptacja_1", $$v)
                    },
                    expression: "form.akceptacja_1",
                  },
                }),
                _vm._v(" "),
                _c("IcFormButtons", {
                  attrs: {
                    sending: _vm.isSending,
                    error: _vm.isError,
                    message: _vm.errorMessage,
                    zmienClick: _vm.zmienKarte,
                  },
                  on: { click: _vm.submit },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isSent
      ? _c("section", { attrs: { id: "thankyou" } }, [
          _c(
            "div",
            {
              staticClass: "alert alert-success _WithIcon",
              staticStyle: { "font-size": "18px" },
              attrs: { role: "alert" },
            },
            [
              _c(
                "span",
                { staticClass: "Text", staticStyle: { "font-size": "22px" } },
                [_vm._v(" " + _vm._s(_vm.$t("ic_kk_dziekujemy")))]
              ),
            ]
          ),
          _vm._v(" "),
          _c("p", [
            _vm._v(" " + _vm._s(_vm.$t("ic_kk_zamowienie_przyjete_1")) + " "),
            _c("strong", [_vm._v(_vm._s(_vm.sentData.formNumber))]),
            _vm._v(
              " " + _vm._s(_vm.$t("ic_kk_zamopwienie_przyjete_2")) + "\n      "
            ),
          ]),
          _vm._v("\n      " + _vm._s(_vm.$t("ic_kk_dane")) + "\n      "),
          _c("p"),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("span", { staticClass: "badge" }, [_vm._v("OFERTA DLA BIZNESU")]),
        _vm._v(" "),
        _c("h1", [_vm._v("Dobrze policzone przejazdy")]),
        _vm._v(" "),
        _c("p", { staticClass: "mt-3 mb-3" }, [
          _vm._v(
            "\n                Twoja firma pędzi do sukcesu. Sprawdź ofertę dla często podróżujących i korzystaj z pociągów PKP INTERCITY na terenie całego kraju. "
          ),
          _c("br"),
          _c("br"),
          _c("b", [
            _vm._v("Skorzystaj z Kolorowych Kart PKP INTERCITY już dziś!"),
          ]),
        ]),
        _vm._v(" "),
        _c("h2", [_vm._v("4 kroki do oszczędności")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Wybierz kartę optymalną dla Twojej firmy. Skorzystaj z kalkulatora i sprawdź, ile możesz zaoszczędzić.\n          "
          ),
          _c("br"),
          _vm._v(" "),
          _c("b", [
            _vm._v(
              "Pamiętaj, że jeśli prowadzisz firmę możesz uwzględnić wydatek poniesiony na zakup karty w swoich rozliczeniach podatkowych"
            ),
            _c("sup", [_vm._v("1")]),
            _vm._v("."),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-7" }, [
        _c("div", {
          staticStyle: {
            width: "100%",
            "padding-bottom": "59.06362545018007%",
            "background-image": "url(/images/karta-head.png?v=3)",
            "background-repeat": "no-repeat",
            "background-position": "center",
            "background-size": "100%",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex row" }, [
      _c("div", { staticClass: "col-12 col-md-6 order-0 order-md-0" }, [
        _c("div", {
          staticClass: "bg-img",
          staticStyle: { "background-image": "url(/images/kk_1.jpg)" },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 w-head order-1 order-md-1" }, [
        _c("h3", { staticClass: "ico-1" }, [_vm._v("Dbasz o finanse")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Oszczędzasz na kosztach podróży: wybierając Kolorowe Karty Intercity, zyskujesz nielimitowane przejazdy pociągami PKP INTERCITY oraz innych przewoźników: POLREGIO, PKP Szybka Kolej Miejska w Trójmieście, Warszawska Kolej Dojazdowa, Koleje Dolnośląskie."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 w-head order-3 order-md-2" }, [
        _c("h3", { staticClass: "ico-2" }, [_vm._v("Masz chwilę dla siebie")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Nasze pociągi wyposażone są w gniazdka i Wi-Fi. Prowadź prezentacje, umawiaj spotkania biznesowe lub po prostu zrelaksuj się oglądając ulubione seriale."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 order-2 order-md-3" }, [
        _c("div", {
          staticClass: "bg-img pull-right",
          staticStyle: { "background-image": "url(/images/kk_2.jpg)" },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 order-4 order-md-4" }, [
        _c("div", {
          staticClass: "bg-img",
          staticStyle: { "background-image": "url(/images/kk_3.jpg)" },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 w-head order-5 order-md-5" }, [
        _c("h3", { staticClass: "ico-3" }, [_vm._v("Zyskujesz czas")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Wybrane trasy pokonasz w czasie krótszym niż podróż samochodem. Po dotarciu na miejsce nie musisz korzystać z dodatkowego środka transportu i stać w korkach. Dworce zlokalizowane są w centrach miast."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 w-head order-7 order-md-6" }, [
        _c("h3", { staticClass: "ico-4" }, [
          _vm._v("Troszczysz się o ekologię"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Nowoczesny tabor emituje ponad 3 razy mniej CO2 niż transport drogowy i ponad 8 razy mniej niż transport lotniczy. Wszystkie nowe pojazdy PKP INTERCITY są zbudowane z  ekologicznych, podlegających recyklingowi materiałów."
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 order-6 order-md-7" }, [
        _c("div", {
          staticClass: "bg-img pull-right",
          staticStyle: { "background-image": "url(/images/kk_4.jpg)" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }